<template>
    <div class="navbar">
        <el-menu
            :default-active="this.$route.path"
            class="el-menu-demo"
            mode="horizontal"
            router
            background-color="#fff"
            text-color="#333"
            active-text-color="#0084ff"
            style="flex:1"
        >
        <div v-for="(item, i) in navList" :key="i">
            <el-submenu v-if='item.children' :index="'subMenu'+i">
                <template slot="title">{{item.title}}</template>
                <el-menu-item v-for="(menuItem, menuIndex) in item.children" :key="'filter'+menuIndex" :index="menuItem.path">{{menuItem.title}}</el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="item.path">
                <template slot="title">
                <span> {{ item.title }}</span>
                </template>
            </el-menu-item>
        </div>
        </el-menu>

    </div>
</template>

<script>

export default {
    data() {
        return{
            navList:[
                {path:'/', title:'首页', children: [{path: '/project/list', title: '项目列表'}, {path: '/project/detail', title: '项目详情'}]},
            ]
        }
    },
    components: {

    },
    computed: {
    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
.navbar {
    height: 50px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    .hamburger-container {
        line-height: 46px;
        height: 100%;
        float: left;
        cursor: pointer;
        transition: background 0.3s;
        -webkit-tap-highlight-color: transparent;

        &:hover {
            background: rgba(0, 0, 0, 0.025);
        }
    }

    .breadcrumb-container {
        float: left;
    }

    .right-menu {
        float: right;
        height: 100%;
        line-height: 50px;

        &:focus {
            outline: none;
        }

        .right-menu-item {
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 18px;
            color: #5a5e66;
            vertical-align: text-bottom;

            &.hover-effect {
                cursor: pointer;
                transition: background 0.3s;

                &:hover {
                    background: rgba(0, 0, 0, 0.025);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue